<avi-state-page>
    <avi-state-page_main-content>
        <avi-page-header 
            headerText="{{ l10nKeys.headerLabel | vtranslate }}"
            [showTimeframeSelector]="true"
            [showMetricValuesSelector]="true"
        ></avi-page-header>
        <avi-metrics-collection-data-grid
            gridTitle="{{ l10nKeys.vsLabel | vtranslate : vsCollection.getTotalNumberOfItems() }}"
            id="vs-list-grid"
            [config]="vsGridConfig"
        ></avi-metrics-collection-data-grid>
    </avi-state-page_main-content>
</avi-state-page>

<ng-template
    #vsFqdnGridCellTemplate
    let-row
>
    <span *ngIf="row.getConfig().dns_info?.length === 0">
        {{ row.getConfig().fqdn ?? (globalL10nKeys.notApplicableLabel | vtranslate) }}
    </span>
    <span *ngIf="row.getConfig().dns_info?.length">
        {{ row.getConfig().dns_info[0].fqdn }}
        <span
            *ngIf="row.getConfig().dns_info.length > 1"
            [aviTitle]="l10nKeys.editToViewAllMessage | vtranslate"
        >
            {{ l10nKeys.columnValueSuffix | vtranslate : row.getConfig().dns_info.length - 1 }}
        </span>
    </span>
</ng-template>
<ng-template
    #vsNameGridCellTemplate
    let-row
>
    <a [title]="row.getName()" (click)="redirectToVsDetailAnalytics(row)">
        {{ row.getName() }}
    </a>
</ng-template>
<ng-template
    #healthTemplateRef
    let-row
>
    <div 
        class="vs-list__health-score-row"
        *ngIf="row.data?.runtime && !vsCollection?.busy"
    >
        <avi-health-score
            class="vs-list__health-score avi-health-score-wrapper"
            id="vs-health-score-{{ row.id | slug }}"
            [runTime]="row.data"
            [objectName]="row.objectName"
            [isWafPolicyInEvaluationMode]="isWafPolicyInEvaluationMode(row)"
            (onViewHealthClick)="redirectToHealthPage(row.id)"
        >
        </avi-health-score>
        <span *ngIf="row.getConfig().enabled">
            {{ row.data?.health_score?.health_score }}
        </span>
    </div>
</ng-template>
<ng-template
    #poolTemplateRef
    let-row
>
    <span class="ellipsify nowrap">
        <span *ngFor="let pool of row.data.pools; let last = last">
            <a
                [title]="row.getName()"
                (click)="redirectToPoolAnalytics(row, pool)"
            >
                {{pool | name}}
            </a>
            <span *ngIf="!last">,&nbsp;</span>
        </span>
    </span>
</ng-template>
<ng-template
    #poolGroupTemplateRef
    let-row
>
    <span class="ellipsify nowrap">
        <span
            *ngFor="let poolGroup of row.data.poolgroups; let last = last"
        >
            {{ poolGroup | name }}
            <span *ngIf="!last">,&nbsp;</span>
        </span>
    </span>
</ng-template>
<ng-template
    #virtualHostingTemplateRef
    let-row
>
    <span class="ellipsify nowrap">
        <span *ngIf="row.getConfig().vh_parent_vs_ref">
            <a (click)="redirectToParentVsDetailAnalytics(row)">
                {{ row.getConfig().vh_parent_vs_ref | name }}
            </a>
        </span>
        <ng-container *ngIf="row.getRuntimeData().vh_child_vs_ref">
            <span *ngFor="let childRef of row.getRuntimeData().vh_child_vs_ref; let last = last">
                <a (click)="redirectToChildVsDetailAnalytics(childRef)">
                    {{ childRef | name }}
                </a>
                <span *ngIf="!last">,&nbsp;</span>
            </span>
        </ng-container>
    </span>
</ng-template>
<ng-template
    #vsServiceEngineTemplateRef
    let-row
>
    <span 
        class="ellipsify nowrap"
        title="{{ getServiceEngineNames(row) }}"
        *ngIf="row.data.runtime?.vip_summary"
    >
        <span *ngFor="let vip of row.data.runtime.vip_summary;
            trackBy: trackByVipId;
            let lastVip = last"
        >
            <span *ngFor="let se of getSortedServiceEngines(vip.service_engine);
                trackBy: trackBySeUuid;
                let lastSe = last"
            >
                <a
                    (click)="redirectToServiceEngineDetailsPage(row, se.url)"
                    [ngClass]="{ 'bold': se.primary, 'permission-denied': !authService.isAllowed('PERMISSION_SERVICEENGINE', 'rw') }"
                >
                   {{ getServiceEngineLabel(se) }}{{ lastVip && lastSe ? '' : ', ' }}
                </a>
            </span>
        </span>
    </span>
</ng-template>
<ng-template
    #alertTemplateRef
    let-row
>
    <div *ngIf="!vsCollection.busy">
        <avi-alert-bell
            class="vs-list__alerts"
            id="avi-alert-bell-{{ row.id | slug }}"
            [runTime]="row.data"
            (onViewAlertsClick)="redirectToVsAlertsPage(row.id)"
        ></avi-alert-bell>
    </div>
</ng-template>
<ng-template
    #virtualHostingRef
    let-row
>
    <div class="vs-list-virtual-hosting-cell">
        <div *ngIf="!getVsTypeLabel(row.getConfig().type)">
            <span class="vs-list-virtual-hosting-cell__no-data">&#8212;</span>
        </div>
        <div *ngIf="getVsTypeLabel(row.getConfig().type)">
            <span>
                {{ getVsTypeLabel(row.getConfig().type) | vtranslate }}
            </span>
            <span>
                ({{ getVhTypeLabel(row.getConfig().vh_type) | vtranslate }})
            </span>
        </div>
    </div>
</ng-template>
<ng-template
    #vsAddressGridCellTemplate
    let-row
>
    <vs-address-grid-cell [vs]="row"></vs-address-grid-cell>
</ng-template>
